// De hamburgerlade liet zich niet sluiten: de klik werd door twee kanten
// afgehandeld (Dawn én de standaardactie van <summary>), waardoor de stand
// twee keer omklapte en de lade 'open' bleef zonder de klasse menu-opening.
//
// Dawn bindt zijn handler al tijdens het parsen, dus er tussen komen met
// stopImmediatePropagation lukt niet. Daarom vervangen we de hoofd-summary
// door een kloon: die heeft geen listeners meer, en wij zijn de enige die
// schakelt. Submenu's binnen de lade blijven ongemoeid.
(function () {
  function koppel() {
    var lade = document.querySelector('header-drawer');
    if (!lade || lade.dataset.zsGekoppeld === 'ja') return;

    var details = lade.querySelector('details.menu-drawer-container');
    var summary = details && details.querySelector(':scope > summary');
    if (!details || !summary) return;

    lade.dataset.zsGekoppeld = 'ja';

    // De header zit in een sticky .shopify-section met z-index 3; die maakt een
    // eigen stapelcontext waardoor de lade niet boven de aankondigingsbalk
    // (z-index 4) kan komen. Zolang het menu open is tillen we die sectie op.
    var headerSectie = lade.closest('.shopify-section');

    var overlay = document.querySelector('.zs-menu-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'zs-menu-overlay';
    }
    // De verduistering hoort in dezelfde sectie als de lade. Aan de body
    // hangend valt hij altijd onder de opgetilde headersectie, waardoor het
    // logo en de aankondigingsbalk onverduisterd bleven. Binnen de sectie
    // kunnen we hem tussen de headerinhoud en de lade leggen.
    var overlayOuder = headerSectie || document.body;
    if (overlay.parentNode !== overlayOuder) {
      overlayOuder.appendChild(overlay);
    }

    var schoon = summary.cloneNode(true);
    summary.parentNode.replaceChild(schoon, summary);

    function open() {
      window.clearTimeout(sluitTimer);
      if (headerSectie) headerSectie.classList.add('zs-menu-actief');
      details.setAttribute('open', '');
      // Reflow forceren zodat de beginstand vaststaat en de overgang loopt.
      void details.offsetHeight;
      details.classList.add('zs-open');
      overlay.classList.add('is-open');
      if (typeof lade.openMenuDrawer === 'function') {
        lade.openMenuDrawer(schoon);
      }
    }

    var sluitTimer = null;

    function sluit(e) {
      if (typeof lade.closeMenuDrawer === 'function') {
        lade.closeMenuDrawer(e || new Event('click'), schoon);
      }
      // Eerst alleen de klasse weghalen: lade en overlay schuiven/faden uit.
      // Het open-attribuut blijft staan tot die overgang klaar is, anders
      // verdwijnt de overlay abrupt en zie je hem knipperen.
      details.classList.remove('zs-open');
      details.classList.remove('menu-opening');
      overlay.classList.remove('is-open');
      schoon.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');

      // Het open-attribuut pas weghalen als de lade uit beeld is; anders
      // verbergt <details> de inhoud meteen en zie je geen overgang.
      window.clearTimeout(sluitTimer);
      sluitTimer = window.setTimeout(function () {
        if (!details.classList.contains('zs-open')) {
          details.removeAttribute('open');
          if (headerSectie) headerSectie.classList.remove('zs-menu-actief');
        }
      }, 450);
    }

    // Sluitknop rechtsboven, zoals in de winkelwagen.
    var lade_inner = details.querySelector('.menu-drawer__inner-container');
    if (lade_inner && !lade_inner.querySelector('.menu-drawer__close')) {
      var sluitknop = document.createElement('button');
      sluitknop.type = 'button';
      sluitknop.className = 'menu-drawer__close';
      sluitknop.setAttribute('aria-label', 'Menu sluiten');
      sluitknop.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L18 18M18 2L2 18" stroke="currentColor" stroke-width="2"/></svg>';
      sluitknop.addEventListener('click', function (e) { sluit(e) });
      lade_inner.insertBefore(sluitknop, lade_inner.firstChild);
    }

    schoon.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.hasAttribute('open')) sluit(e);
      else open();
    });

    overlay.addEventListener('click', function (e) { sluit(e) });

    // Sluiten met Escape en door naast de lade te klikken.
    document.addEventListener('keyup', function (e) {
      if (e.code === 'Escape' && details.classList.contains('zs-open')) sluit(e);
    });

    document.addEventListener('click', function (e) {
      if (!details.classList.contains('zs-open')) return;
      if (details.contains(e.target)) return;
      sluit(e);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', koppel);
  } else {
    koppel();
  }
})();
